import rules from './fieldVisibilityRules';
import { reportBase, cohorts } from './reportsBase';

const TYPE = 'crossDevice';

export default {
    type: TYPE,
    fields: [
        ...reportBase.fields,
        ...cohorts.fields,
        'custom_dimensions',
        'xorgMetrics',
        'xorgCohortMetrics',
        'fileCombinerDimensions',
        'granularityLevels',
        'enrichmentDimensions',
        'trackerData',
        'networkData',
        'discrepancies',
        'metadataDimensions',
        'sourceAttributionType',
        'crossDeviceDemoCohortType',
        'appMetrics',
        'webMetrics',
        'crossDeviceMetrics',
        'crossDeviceCohortType',
    ],
    visibleRule: rules[TYPE],
    dataSelector: {
        ...reportBase.dataSelector,
        ...cohorts.dataSelector,
        custom_dimensions: 'custom_dimensions',
        fileCombinerDimensions: 'fileCombinerDimensions',
        granularityLevels: 'granularityLevels',
        enrichmentDimensions: 'enrichmentDimensions',
        trackerData: 'trackerData',
        networkData: 'networkData',
        discrepancies: 'discrepancies',
        metadataDimensions: 'metadataDimensions',
        xorgMetrics: 'xorgMetrics',
        xorgCohortMetrics: 'xorgCohortMetrics',
        sourceAttributionType: 'sourceAttributionType',
        selectedTab: 'selectedTab',
        transparencyDataFormatted: 'reportData',
        tableDataFormatted: 'reportData',
        chartDataFormatted: 'chartData',
        chart: 'chart',
        mode: 'mode',
        unenriched: 'unenriched',
        shouldDrilldown: 'shouldDrilldown',
        isClearSelectionOn: 'isClearSelectionOn',
        appMetrics: 'appMetrics',
        webMetrics: 'webMetrics',
        crossDeviceMetrics: 'crossDeviceMetrics',
        crossDeviceCohortType: 'crossDeviceCohortType',
    },
};
